import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Route } from '@angular/router';

import { AuthService } from '@app/shared/services/auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private authService: AuthService) {}

  public canActivate(route: ActivatedRouteSnapshot) {
    return this.checkLogin();
  }

  public canLoad(route: Route): boolean {
    return this.checkLogin();
  }

  public checkLogin(): boolean {
    // Redirect to login url if not authenticated. This should instead use straight up routing once we have an Angular login route
    if (!this.authService.isLoggedIn) {
      this.authService.logout(false, true);
      return false;
    }
    return true;
  }
}
